import axios from 'axios';

import formatForFeed from './formatForFeed';
import sortVideos from './sortVideos';

const getEpisode = function getEpisodeDataFromYouTube(
  videos,
  key,
  languageId,
  match
) {
  const vidArray = videos.map(vid => vid.id);
  const id = vidArray.toString();
  return axios
    .get('https://www.googleapis.com/youtube/v3/videos', {
      params: {
        part: 'snippet,localizations',
        id,
        key,
        maxResults: 50,
      },
    })
    .then(res => {
      const data = sortVideos(res.data.items, videos);
      return formatForFeed(data, languageId, match);
    })
    .catch(err => err);
};

export default getEpisode;



// WEBPACK FOOTER //
// ./src/components/getEpisodes/getEpisodes.js